import { DogSummary } from "types/Dog";

export const sortDogs = (a: DogSummary, b: DogSummary, dogListSortType: string) => {
    if (dogListSortType === 'oldest') {
        if (a.createTs > b.createTs) {
            return 1;
        } else if (a.createTs < b.createTs) {
            return -1;
        } else {
            return 0;
        }
    } else if (dogListSortType === 'newest') {
        if (b.createTs > a.createTs) {
            return 1;
        } else if (b.createTs < a.createTs) {
            return -1;
        } else {
            return 0;
        }
    } else {
        return a[dogListSortType].localeCompare(b[dogListSortType]);
    }
}